import moment from 'moment'

import { TagType } from 'Shared/atoms/Tag/types'

import { SortDirection } from 'Core/interfaces/sorting'

import { DocumentStatus } from 'Portals/Supplier/entities/Document'
import i18n from 'Portals/Supplier/utils/i18nService'

export const defaultSorting = {
	field: 'lastUpdateDate',
	order: SortDirection.DESC
}

export const isDocumentRelateToSupplier = (documentType = '') =>
	[
		'msa',
		'nda',
		'terms & conditions',
		'certificate of insurance',
		'proof of insurance',
		'adoption agreements'
	].includes(documentType.toLowerCase())

export const isDocumentRelateToSupplierLocation = (documentType = '') =>
	['w9', 'eft'].includes(documentType.toLowerCase())

export const MAP_STATUS_TO_TAG: Record<DocumentStatus, TagType> = {
	[DocumentStatus.Active]: 'green',
	[DocumentStatus.Inactive]: 'default',
	[DocumentStatus.Pending]: 'violet',
	[DocumentStatus.Rejected]: 'lightRed'
}

export const getTooltipText = (expirationDate: BasicString): BasicString => {
	if (!expirationDate) {
		return null
	}

	const currentDate = moment()
	const daysInMonth = moment(expirationDate).daysInMonth()

	const diffDays = moment(expirationDate).diff(currentDate, 'days')

	if (diffDays < 0) {
		return i18n.t('constants:DOCUMENT_IS_EXPIRED_MESSAGE')
	}

	if (diffDays <= daysInMonth) {
		return i18n.t('constants:DOCUMENT_IS_ABOUT_TO_EXPIRE_MESSAGE')
	}

	return null
}
